if (!customElements.get('font-gallery-tabs')) {
  customElements.define(
    'font-gallery-tabs',
    class FontGalleryTabs extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.stage = this.querySelector('[role="tabpanel"]');
        this.track = this.querySelector('.font-gallery__track');
        this.prevButton = this.querySelector('.font-gallery__arrow--prev');
        this.nextButton = this.querySelector('.font-gallery__arrow--next');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab), { signal });
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab), { signal });
        });

        this.prevButton.addEventListener('click', () => this.scrollByPage(-1), { signal });
        this.nextButton.addEventListener('click', () => this.scrollByPage(1), { signal });
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal });
        window.addEventListener('resize', () => this.updateArrows(), { signal });

        const initialTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        if (initialTab) this.select(initialTab);
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
      }

      select(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        this.stage.setAttribute('aria-labelledby', selectedTab.id);
        this.track.setAttribute('aria-label', selectedTab.textContent.trim() + ' photos');

        const template = this.querySelector('template[data-font="' + selectedTab.dataset.font + '"]');
        this.track.replaceChildren();
        if (template) this.track.append(template.content.cloneNode(true));

        this.track.scrollLeft = 0;
        this.updateArrows();
        requestAnimationFrame(() => this.updateArrows());
      }

      scrollByPage(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (this.track.clientWidth + gap), behavior: 'smooth' });
      }

      updateArrows() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.prevButton.hidden = this.track.scrollLeft <= 4;
        this.nextButton.hidden = maxScroll <= 4 || this.track.scrollLeft >= maxScroll - 4;
      }

      handleKeydown(event, tab) {
        const index = this.tabs.indexOf(tab);
        let nextTab;

        if (event.key === 'ArrowRight') nextTab = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') nextTab = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        if (event.key === 'Home') nextTab = this.tabs[0];
        if (event.key === 'End') nextTab = this.tabs[this.tabs.length - 1];
        if (!nextTab) return;

        event.preventDefault();
        nextTab.focus();
        this.select(nextTab);
      }
    }
  );
}